module.exports = __webpack_public_path__ + "img/reg-class.1909d414.jpeg";